export default {
	ResetToDefault: {
		message:
			"Are you sure you want to reset the dashboard to its default state? All the customized widget will be removed."
	},
	widgetConfigurationUpdateSuccess: {
		message: "Configuration updated successfully.",
		code: 10000
	},
	sectionPermissionsurationUpdateSuccess: {
		message: "Permissions updated successfully.",
		code: 10000
	},
	sectionPermissionsurationUpdateFailed: {
		message: "Unable to update permissions.",
		code: 10000
	},
	widgetConfigurationAddedSuccess: {
		message: "Widget added successfully.",
		code: 10000
	},
	widgetConfigurationUpdateFail: {
		message: "Unable to update widget configuration.",
		code: 500
	},
	widgetConfigurationAddFail: {
		message: "Unable to save widget configuration.",
		code: 500
	},
	somethingWrong: { message: "Something went wrong...", code: 500 },
	browserNotSupported: {
		message:
			"browser is not supported. Upgrade to the latest version of Chrome, Edge, or Mozilla.",
		code: 1003
	},

	noChange: { message: "No changes made in data...", code: 1005 },
	valueMustBeSelected: { message: "Value must be selected!", code: 1006 },
	alreadyExists: { message: "already exists", code: 1008 },

	pageNotFound: {
		heading: "Oops! Page Not Found",
		message:
			"Sorry but the page you are looking for does not exist, have been removed. name changed or is temporarily unavailable",
		code: 404,
		goToHomeEnabled: true
	},
	serverError: {
		heading: "Oops! Something went wrong",
		message:
			"Sorry something went wrong at server side, either refresh the page or try after some time. If issue still persist please contact your site administrator.",
		code: 500,
		goToHomeEnabled: true
	},
	unAuthorizedAccess: {
		heading: "Unable to Access",
		message:
			"Sorry it seems you are not able to access portal/resources, please contact site administrator.",
		code: 403,
		goToHomeEnabled: false
	},
	sessionTimeOut: {
		heading: "Session Timeout",
		message:
			"Sorry it seems your session is no more active, please sign in again.",
		code: 401,
		goToHomeEnabled: true
	},
	deleteTenantConfirmation: {
		message:
			"Are you sure you want to delete the Tenant? All the contacts related to Tenant will also gets removed."
	},
	sendEmailConfirmation: {
		message: "Are you sure you want to Send Invitation Email?"
	},
	fileMaxSize: {
		message:
			"File size should be less than 30MB. Please try again after reducing file size of file/files- "
	},
	reportingDateExceed: {
		message:
			"Selected Date Range is more than 12 months. Please select Date Range less than or equal to 12 months."
	},
	proofOfIdentityMessage: {
		message:
			"Request not found in this Data center. Please present credentials to Security Officer to verify Request."
	},
	searchSectionMessage: {
		message: "Please fill atleast one field to search."
	},
	enableBrrSectionMessage: {
		message:
			"Have you read the Stream Data Center Building Rules and Regulations Guidelines?"
	},
	errorMessageExpiration: {
		message: "Please enter valid data in Expiration Date field."
	},
	errorMessageDateOfBirth: {
		message: "Please enter valid data in Date Of Birth field."
	},
	printBRRABRFMessageError: {
		message:
			"Facing issues while printing BRR and ABRF form, Please contact your administrator."
	},
	deleteDistributionConfirmation: {
		message: "Are you sure you want to delete the Distribution Group?"
	},
	printHSEMessageError: {
		message:
			"Facing issues while printing HSE form, Please contact your administrator."
	},
	printSecurityMessageError: {
		message:
			"Facing issues while printing Security form, Please contact your administrator."
	},
	deactivationForStatusConfirmation: {
		message: "Are you sure you want to active the Incident Status?"
	},
	activationForStatusConfirmation: {
		message: "Are you sure you want to inactive the Incident Status?"
	},
	deactivationForCategoryConfirmation: {
		message: "Are you sure you want to active the Incident Category?"
	},
	activationForCategoryConfirmation: {
		message: "Are you sure you want to inactive the Incident Category?"
	},
	deactivationForSubCategoryConfirmation: {
		message: "Are you sure you want to active the Incident Sub Category?"
	},
	activationForSubCategoryConfirmation: {
		message: "Are you sure you want to inactive the Incident Sub Category?"
	},
	biometricMessage: {
		message:
			"This request requires a mandatory signature on Biometric Form."
	},
	enableBiometricSectionMessage: {
		message:
			"Have you read the Stream Data Center Biometric Agreement?"
	},
};
